import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left-dis",
  "use": "icon-arrow--left-dis-usage",
  "viewBox": "0 0 7 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 9\" id=\"icon-arrow--left-dis\"><path d=\"M.92 5.268a1 1 0 0 1 0-1.536L5.11.239a1 1 0 0 1 1.64.768v6.986a1 1 0 0 1-1.64.768L.92 5.268Z\" fill=\"#CCC\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol